import { Box, Brand, Img, LogoAt, Page, Text } from "../primitives";
/** Reference page 6 — «نحول الجدران إلى مساحة نابضة بالحياة». Fully fixed. */
export function WallsPage() {
    return (<Page background="#000000">
      <Box x={0} y={0} w={1125} h={810} style={{ overflow: "hidden" }}>
        <Img src="/proposal-assets/template/walls-collage.jpg" x={0} y={0} w={1145.6} h={810}/>
        <Box x={0} y={0} w={1125} h={810} style={{ background: "#000000", opacity: 0.58 }}/>
      </Box>
      <LogoAt cx={80} cy={97.5} w={32} color="#ffffff"/>
      <Brand right={1083} top={63} size={34} color="#ffffff"/>
      <Text right={1090} top={646} size={40} weight={700} color="#ffffff">
        نحول الجدران إلى
      </Text>
      <Text right={1090} top={712} size={40} weight={700} color="#ffffff">
        مساحة نابضة بالحياة
      </Text>
    </Page>);
}
